import bear from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/bear.png";
import cat from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/cat.png";
import deer from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/deer.png";
import fox from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/fox.png";
import frog from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/frog.png";
import hare from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/hare.png";
import hedge from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/hedge.png";
import mouse from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/mouse.png";
import owl from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/owl.png";
import raccoon from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/raccoon.png";
import turtle from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/turtle.png";
import wolf from "@/design-system/syncani-brandbook-9219d6/assets/illustrations/animals/wolf.png";

import type { AnimalId } from "./campData";

export const ANIMAL_FIGURES: Record<AnimalId, string> = {
  bear,
  cat,
  deer,
  fox,
  frog,
  hare,
  hedge,
  mouse,
  owl,
  raccoon,
  turtle,
  wolf,
};
